<template>
    <div class="teammates-lineup-wrapper parks-lineup">
        <div class="available-teammates">
            <h6 class="d-flex flex-wrap align-items-center justify-content-between" style="gap: 5px;">
                <span>Available Parks</span>
                <button class="btn create-event" @click="checkCurd">Add Park</button>
            </h6>
            <div class="teammates-info overflow-hidden">
                <div class="search-container mw-100 border-0 mx-2">
                    <form>
                        <button type="button">
                            <img src="../../../assets/images/search.png" alt="" />
                        </button>
                        <input v-model="searchValue" id="search-input" type="text" placeholder="Search by Park Name"
                            name="search" autocomplete="new-password" v-on:keydown.enter.prevent />
                    </form>
                </div>
                
                <draggable class="list-group" :list="filteredAvailableParks" group="people" handle=".handle"
                    @change="handleAvailableParks" v-if="showLoaderAvailableParks == 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in filteredAvailableParks"
                        :key="index">
                        <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column align-items-start">
                                <p class="name">{{ element?.park_name }}</p>
                                <small>{{ element?.field_count }} {{ element?.field_count === 1 ||
                                    element?.field_count
                                    === 0 ? 'Field' : 'Fields' }}</small>
                            </div>
                        </div>
                        <div class="handle cursor-pointer">
                            <img src="../../../assets/images/line-ellipsis.png" alt=""
                                title="Click an icon to drag and drop the option." />
                        </div>
                    </div>
                </draggable>
                <div class="no-line-up" v-if="
                    showLoaderAvailableParks == 0 &&
                    availableParks.length == 0
                ">
                    <div class="img">
                        <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No available parks found. Try adding parks from the city associated with this
                        event.
                    </p>
                </div>
                <div class="lds-dual-ring-media" v-if="showLoaderAvailableParks == 1"></div>
            </div>
        </div>
        <div class="team-lineup">
            <h6 class="text-left" style="padding-top: 10px; padding-bottom: 5px;">Selected Parks</h6>
            <div class="teammates-info position-relative">
                <draggable class="list-group" :list="selectedParks" group="people" handle=".handle"
                    @change="handleSelectedParks" v-if="showLoaderSelectedParks == 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in selectedParks"
                        :key="element?.position_index">
                        <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column align-items-start">
                                <p class="name">{{ element?.park_name }}</p>
                                <small>{{ element?.field_count }} {{ element?.field_count === 1 ||
                                    element?.field_count
                                    === 0 ? 'Field' : 'Fields' }}</small>
                            </div>
                        </div>
                        <div class="handle cursor-pointer">
                            <img src="../../../assets/images/line-ellipsis.png" alt=""
                                title="Click an icon to drag and drop the option." />
                        </div>
                    </div>
                </draggable>
                <div class="no-line-up" v-if="
                    showLoaderSelectedParks == 0 && selectedParks.length == 0
                ">
                    <div class="img">
                        <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected parks found.</p>
                </div>
                <div class="lds-dual-ring-media" v-if="showLoaderSelectedParks == 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
export default {
    data() {
        return {
            searchValue: "",
            availableParks: [],
            selectedParks: [],
            showLoaderAvailableParks: 1,
            showLoaderSelectedParks: 1,
        };
    },
    components: {
        draggable,
    },
    props: {
        eventId: {
            type: [Number, String],
        },
        association_id: {
            type: [Number, String],
        },
    },
    computed: {
        filteredAvailableParks() {
            const lowercasedSearchValue = this.searchValue.toLowerCase();
            return this.availableParks.filter((park) => {
                const isSelected = this.selectedParks.some(
                    (selected) => selected.id === park.id
                );
                const parkName = park.park_name.toLowerCase();

                return (
                    !isSelected &&
                    parkName.includes(lowercasedSearchValue)
                );
            });
        },
    },
    watch: {
        selectedParks: function (newValue) {

            if (newValue.length > 0 || this.availableParks.length > 0) {
                const isDisabled = false;
                this.$emit('update-state', {
                    isDisabled,
                    selectedParks: this.selectedParks
                });
            } else {
                const isDisabled = true;
                this.$emit('update-state', isDisabled);
            }
        },
        availableParks: function (newValue) {
            if (newValue.length > 0 || this.selectedParks.length > 0) {
                const isDisabled = false;
                this.$emit('update-state', {
                    isDisabled,
                    selectedParks: this.selectedParks
                });
            } else {
                const isDisabled = true;
                this.$emit('update-state', isDisabled);
            }
        },
    },
    methods: {
        checkCurd() {
            this.$emit("close-manage-modal");
            this.$root.$emit("openAddParksModal", { eventId: this.eventId, association_id: this.association_id });
        },
        handleAvailableParks(evt) {
            if (evt.added) {
                this.selectedParks.push(evt.added.element);
            }
        },
        handleSelectedParks(evt) {
            if (evt.removed) {
                const index = this.selectedParks.indexOf(evt.removed.element);
                if (index > -1) {
                    this.selectedParks.splice(index, 1);
                }
            }
        },

        async getPlayingFacilityForAssociation() {
            try {
                this.showLoaderSelectedParks = 1;
                this.showLoaderSelectedParks = 1;

                // Prepare the parameters
                // const params = {
                //     event_id: this.eventId,
                //     association_id: this.association_id,
                // };

                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility?event_id=${this.eventId}&association_id=${this.association_id}`
                );

                if (response.data.statusCode === 200) {
                    this.selectedParks = Object.values(response.data.data.parkDetails);
                    this.showLoaderSelectedParks = 0;
                }
                else if (response.data.statusCode === 404) {
                    this.closeModal();
                    // this.$alert(response.data.message, 'Error');
                    // this.$router.push({ name: "Teams" });
                }
                else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderSelectedParks = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderSelectedParks = 0;
            }
        },
        async getPlayingFacilities() {
            try {
                this.showLoaderAvailableParks = 1;
                console.log(this.showLoaderAvailableParks)
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getParksForEventManagement?event_id=${this.eventId}&association_id=${this.association_id}`
                );

                if (response.data.statusCode === 200) {
                    this.availableParks = Object.values(response.data.data.parks);
                    console.log(this.availableParks)
                    this.showLoaderAvailableParks = 0;
                } else if (response.data.statusCode === 404) {
                    this.closeModal();
                    this.$alert(response.data.message, 'Error');
                    this.$router.push({ name: "Teams" });
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderAvailableParks = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderAvailableParks = 0;
            }
        },
    },
    mounted() {
        this.$root.$on("openManageParksModal", (params) => {
            // Destructure the parameters
            const { eventId, association_id } = params || {};

            // Store these values if needed
            this.eventId = eventId;
            this.association_id = association_id;
            this.getPlayingFacilities();
            this.getPlayingFacilityForAssociation();


        });
        this.getPlayingFacilities();
        this.getPlayingFacilityForAssociation();
        this.searchValue = "";

    }
}
</script>